import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { MaterialsPageType } from '../../store/materials/materials.typing'
import { RootState } from '../../store/rootReducer'
import { MaterialsType } from '../../store/tags/tagsTyping'

import usePageLoaded from '../../hooks/usePageLoaded'
import { useInitOfSavingClearPath } from '../../hooks/useBackButton'

import Title from '../../components/ui/title/title'
import PaginationAndEndlessScrollWrapper from './PaginationAndEndlessScrollWrapper'
import PaginationLoader from '../../components/ui/paginationLoader/PaginationLoader'
import Grid from '../../components/grid/grid'
import MaterialPreview from '../../components/material/materialPreview'
import { PaginationIndexLink } from '../../components/ui/paginationLink/PaginationLink'
import Paragraph from '../../components/ui/paragraph/paragraph'
import SwiperIndexMaterials from '../../components/swiper/swiperIndexMaterials'

import Pagination from 'rsuite/Pagination'
import { Helmet } from 'react-helmet'

import { META } from '../../constants/meta'
import { getLangFromPath } from '../../i18next'
import { clearCertifiedList, fetchCertifiedMaterial } from '../../store/materials/materialsSlice'
import isEmpty from 'lodash/isEmpty'
import '../app.sass'
import './pagination.sass'
import { getContributionMaterial } from '../../api/contributions'

const IndexCertifiedFemAndCouple = (): JSX.Element => {
    usePageLoaded()
    useInitOfSavingClearPath()

    const location = useLocation()
    const [t] = useTranslation()
    const history = useHistory()
    const dispatch = useDispatch()

    const certified = useSelector<RootState, MaterialsPageType>((state) => state.materials.certified)
    const isAgeVerified = useSelector<RootState, boolean>((state) => state.common.isAgeVerified)
    const { list, total_count, loading } = certified

    const [currentPage, setCurrentPage] = useState(1)
    const [currentPhoto, setCurrentPhoto] = useState(null)
    const [isSwiperOpened, setIsSwiperOpened] = useState(false)
    const [forceUpdateList, setForceUpdateList] = useState(false)
    const [notFoundPhoto, setNotFoundPhoto] = useState(null)

    const lastElement = useRef(null)

    const pageFromAdress = () => {
        if (location.search) return Number(new URLSearchParams(location.search).get('p'))
        return undefined
    }

    useEffect(() => {
        if (!new URLSearchParams(location.search).get('id')) setIsSwiperOpened(false)
    }, [location])

    useEffect(() => {
        const id = Number(new URLSearchParams(location.search).get('id'))
        if (id) {
            if (list.findIndex((item) => item.id == id) >= 0) {
                setCurrentPhoto(list[list.findIndex((item) => item.id == id)])
            } else {
                getContributionMaterial({ id }).then((res) => {
                    if (res.material) setNotFoundPhoto(res.material)
                })
            }
        }
    }, [])

    useEffect(() => {
        if (currentPhoto && !isSwiperOpened) setIsSwiperOpened(true)
    }, [currentPhoto])

    useEffect(() => {
        if (forceUpdateList) {
            setForceUpdateList(false)
            if (total_count / 20 > currentPage) {
                setCurrentPage((page) => page + 1)
                dispatch(fetchCertifiedMaterial(currentPage + 1))
            }
        }
    }, [forceUpdateList])

    return (
        <div className="pageContent" style={{ margin: '0 auto', maxWidth: '1360px', padding: '90px 27px' }}>
            <Helmet>
                <title>{META.indexCertifiedFemAndCouple[getLangFromPath(location.pathname)].title}</title>
                <meta
                    name="description"
                    content={META.indexCertifiedFemAndCouple[getLangFromPath(location.pathname)].description}
                />
            </Helmet>
            <Title text={t('Certified females and couples')} />
            <Paragraph text={t('Certified info')} />
            {isSwiperOpened && (
                <div
                    className="swiperMaterialsPopup"
                    onClick={() => {
                        history.replace(location.pathname)
                        setIsSwiperOpened(false)
                    }}
                >
                    <SwiperIndexMaterials list={list} photo={currentPhoto} setForceUpdateList={setForceUpdateList} />
                </div>
            )}
            {notFoundPhoto && (
                <div
                    className="swiperMaterialsPopup"
                    onClick={() => {
                        history.replace(location.pathname)
                        setNotFoundPhoto(null)
                    }}
                >
                    <SwiperIndexMaterials list={[notFoundPhoto]} photo={notFoundPhoto} />
                </div>
            )}
            <PaginationAndEndlessScrollWrapper
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                list={list}
                fetchList={fetchCertifiedMaterial(currentPage)}
                total={total_count}
                clearList={clearCertifiedList()}
                sourcePage={'index'}
                lastElement={lastElement}
                loading={loading}
            >
                <div>
                    <Grid
                        items={list.map((item: MaterialsType) => (
                            <div
                                key={item.id}
                                onClick={(e) => {
                                    e.preventDefault()
                                    setCurrentPhoto(item)
                                    setIsSwiperOpened(true)
                                }}
                            >
                                <MaterialPreview material={item} isAgeVerified={isAgeVerified} isIndex={true} />
                            </div>
                        ))}
                    />
                    <div className="paginationWrapper">
                        {!loading ? (
                            <Pagination
                                ref={lastElement}
                                limit={20}
                                limitOptions={[10]}
                                maxButtons={5}
                                linkAs={PaginationIndexLink}
                                activePage={pageFromAdress() || currentPage}
                                onChangePage={(page: number) => {
                                    history.push({
                                        pathname: location.pathname,
                                        search: `p=${page}`
                                    })
                                }}
                                total={+total_count}
                            />
                        ) : (
                            <PaginationLoader />
                        )}
                    </div>
                </div>
            </PaginationAndEndlessScrollWrapper>
        </div>
    )
}

// @ts-ignore
IndexCertifiedFemAndCouple.getInitialProps = async ({ store, req }) => {
    const {
        materials: { certified }
    } = store.getState()
    const { list } = certified
    if (req) {
        const page = req.query.p

        if (isEmpty(list)) {
            await store.dispatch(fetchCertifiedMaterial(page || 1))
        }
    } else {
        if (isEmpty(list)) await store.dispatch(fetchCertifiedMaterial(1))
    }
}

export default IndexCertifiedFemAndCouple
